import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconPhone = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Phone'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 16 16' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M16.5 -0.666687H15.8334V-2.03252e-05H16.5V-0.666687ZM3.72504 14.9416C3.98615 15.2028 4.30004 15.3333 4.66671 15.3333H11.3334C11.7 15.3333 12.0139 15.2028 12.275 14.9416C12.5362 14.6805 12.6667 14.3666 12.6667 14V1.99998C12.6667 1.63331 12.5362 1.31942 12.275 1.05831C12.0139 0.797202 11.7 0.666646 11.3334 0.666646H4.66671C4.30004 0.666646 3.98615 0.797202 3.72504 1.05831C3.46393 1.31942 3.33337 1.63331 3.33337 1.99998V14C3.33337 14.3666 3.46393 14.6805 3.72504 14.9416ZM4.66671 14V12H11.3334V14H4.66671ZM8.47504 13.475C8.34726 13.6028 8.18893 13.6666 8.00004 13.6666C7.81115 13.6666 7.65282 13.6028 7.52504 13.475C7.39726 13.3472 7.33337 13.1889 7.33337 13C7.33337 12.8111 7.39726 12.6528 7.52504 12.525C7.65282 12.3972 7.81115 12.3333 8.00004 12.3333C8.18893 12.3333 8.34726 12.3972 8.47504 12.525C8.60282 12.6528 8.66671 12.8111 8.66671 13C8.66671 13.1889 8.60282 13.3472 8.47504 13.475ZM11.3334 10.6666H4.66671V3.99998H11.3334V10.6666ZM11.3334 2.66665H4.66671V1.99998H11.3334V2.66665Z"
      />
    </Icon>
  )
}

IconPhone.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconPhone
